<template>
  <div>
    <v-card
        outlined
        :loading="loading"
        style="display: flex; flex-grow: 1; flex-direction: column;"
    >
      <v-card-title>
        <div v-if="!clickableTitle">
          <h4>{{ title }}</h4>
          <h6 class="text-muted">{{ description }}</h6>
        </div>
        <div v-else>
          <router-link :to="'/management/detailed-reports'">
            <h4>{{ title }}</h4>
            <h6 class="text-muted">{{ description }}</h6>
          </router-link>
        </div>
        <v-spacer></v-spacer>
        <slot name="filterAndAction"></slot>
      </v-card-title>
      <v-card-text>
        <slot name="perPage"></slot>
        <slot name="vatExcludedCurrencyAmount"></slot>
        <b-table
            class="custom-table"
            :items="dataList"
            :fields="dataHeaders"
            hover
            small
            responsive
            sort-icon-left
            striped
            head-row-variant="info"
            :per-page="perPage"
            show-empty
            custom-foot
            :foot-clone="footClone"
            :busy="loading"
            style="font-size:12px "
        >
          <template #empty="scope">
            <h6 class="text-center my-5">
              {{ scope.loading ? "Lütfen Bekleyin" : errorMessage ? errorMessage : "Veri Bulunamadı"}}
            </h6>
          </template>
<!--          <template #cell(vatExcludedCurrencyAmount)="data">-->
<!--            <div>-->
<!--                <v-menu-->
<!--                    :v-model="showActionsMenu"-->
<!--                    bottom-->
<!--                >-->
<!--                  <template v-slot:activator="{ on, attrs }">-->
<!--                    <v-btn-->
<!--                        class="mx-1"-->
<!--                        small-->
<!--                        color="primary"-->
<!--                        v-bind="attrs"-->
<!--                        v-on="on"-->
<!--                        @click="showActionsMenu = data.item"-->
<!--                    >-->
<!--                      Tutarı Gör-->
<!--                    </v-btn>-->
<!--                  </template>-->
<!--                  <v-list @click="test(data.item)" >-->
<!--                    <v-list-item-content>-->
<!--                    <v-list-item v-for="(item,i) in data.item" :key="i">-->
<!--                      <v-list-item-content>-->
<!--                        <v-list-item-title> {{ 'USD: ' +  item}} </v-list-item-title>-->
<!--                      </v-list-item-content>-->
<!--                    </v-list-item>-->
<!--                    </v-list-item-content>-->
<!--                  </v-list>-->
<!--                </v-menu>-->
<!--            </div>-->
<!--&lt;!&ndash;            <div class="text-left">&ndash;&gt;-->
<!--&lt;!&ndash;              <v-tooltip top>&ndash;&gt;-->
<!--&lt;!&ndash;                <template v-slot:activator="{ on, attrs }">&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-btn&ndash;&gt;-->
<!--&lt;!&ndash;                      v-bind="attrs"&ndash;&gt;-->
<!--&lt;!&ndash;                      v-on="on"&ndash;&gt;-->
<!--&lt;!&ndash;                      icon&ndash;&gt;-->
<!--&lt;!&ndash;                      color="indigo darken-2"&ndash;&gt;-->
<!--&lt;!&ndash;                  >&ndash;&gt;-->
<!--&lt;!&ndash;                    <v-icon>mdi-check</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                  </v-btn>&ndash;&gt;-->
<!--&lt;!&ndash;                </template>&ndash;&gt;-->
<!--&lt;!&ndash;                <span>{{data.item.vatExcludedAmount}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;              </v-tooltip>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--          </template>-->
          <template #custom-foot>
            <slot name="tableFooter"></slot>
          </template>
          <template #table-busy>
            <div class="text-center">
              <b-spinner
                  variant="primary"
                  size="lg"
                  label="Lütfen Bekleyin..."
              ></b-spinner>
            </div>
          </template>
        </b-table>
      </v-card-text>
      <div v-if="paginationStatus" class="row">
        <div class="col-lg-12 mb-5">
          <v-pagination
              v-model="currentPage"
              class="my-4"
              :total-visible="perPage"
              :length="paginationLength"
          ></v-pagination>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "SimpleDataTable",
  props: {
    clickableTitle: {
      type: Boolean,
      default: false,
    },
    paginationLength: {
      type: Number,
      default: 0,
    },
    paginationStatus: {
      type: Boolean,
      default: false,
    },
    dataList: {
      type: Array,
      default: () => []
    },
    dataHeaders: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    footClone: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 10,
    },
    saleCurrencyAmountProp: {
      type: Array,
      default: () => []
    },
    errorMessage: {
      type: String,
      default: "",
    }
  },
  computed: {
    ...mapState("dashboard", ["errorMessageAll"]),
  },
  data(){
    return {
      currentPage: 1,
      showActionsMenu: true,
    }
  },
  methods: {
  },
  watch:{
    async currentPage(newVal){
      newVal;
      await this.$emit("page-change", newVal);
    }
  },
};
</script>

<style scoped>
.custom-table {
  overflow-y: hidden;
}

.custom-table::-webkit-scrollbar {
  display: none;
}
</style>
